import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    beforeEnter: (to, from, next) => {
      // Redirigir al login de Vue 3 (mdz-administracion)
      const VUE3_URL = process.env.VUE_APP_ADMINISTRACION_URL || 'http://localhost:5173';
      window.location.href = `${VUE3_URL}/login`;
    },
  },
  {
    path: '/listado/:model/',
    name: 'Listado',
    component: () => import('../views/Listado.vue'),
  },
  {
    path: '/nuevo/:model/',
    name: 'Nuevo',
    component: () => import('../views/Nuevo.vue'),
  },
  {
    path: '/editar/:model/:id',
    name: 'Editar',
    component: () => import('../views/Nuevo.vue'),
  },
  {
    path: '/gestionar/:id',
    name: 'Gestionar',
    component: () => import('../views/CreditoView.vue'),
  },
  {
    path: '/reportes',
    name: 'GenerarReportes',
    component: () => import('../views/GenerarReportes/GenerarReportes.vue'),
  },
  {
    path: '/tasavariable/',
    name: 'TasaVariable',
    component: () => import('../views/TasaVariable.vue'),
  },
  {
    path: '/cuotas/',
    name: 'Cuotas',
    component: () => import('../views/Cuotas.vue'),
  },
  {
    path: '/legajos/importarcsv/',
    name: 'ImportarLegajoCsv',
    component: () => import('../views/ImportarCsv.vue'),
  },
  {
    path: '/legajos/importar/',
    name: 'ImportarLegajo',
    component: () => import('../views/ImportarLegajo.vue'),
  },
  {
    path: '/legajos/ImportarCuadroMarcha/',
    name: 'ImportarCuadroMarcha',
    component: () => import('../views/ImportarCuadroMarcha.vue'),
  },
  {
    path: '/legajos/DatosHistoricos/',
    name: 'ImportarDatosHistoricos',
    component: () => import('../views/ImportarDatosHistoricos.vue'),
  },
  {
    path: '*',
    component: () => import('../views/404.vue'),
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
  },
  {
    path: '/pass',
    name: 'Pass',
    component: () => import('../views/Pass.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  console.log('🔍 [Vue 2 Router Guard] =================================');
  console.log('🔍 [Vue 2 Router Guard] Navegando a:', to.name || to.path);
  console.log('🔍 [Vue 2 Router Guard] Desde:', from.name || from.path);
  console.log('🔍 [Vue 2 Router Guard] Query params:', to.query);

  // Procesar datos de usuario desde query string (cuando viene de Vue 3)
  const tokenQuery = to.query.token;
  if (tokenQuery) {
    console.log('✅ [Vue 2 Router Guard] Token recibido de Vue 3, guardando en localStorage');
    console.log('🔍 [Vue 2 Router Guard] Rol del usuario:', to.query.rol);

    // Guardar todos los datos del usuario en localStorage
    localStorage.setItem('token', tokenQuery);
    localStorage.setItem('user_id', to.query.user_id || '');
    localStorage.setItem('email', to.query.email || '');
    localStorage.setItem('username', to.query.username || '');
    localStorage.setItem('emailStatus', to.query.emailStatus || '');
    localStorage.setItem('rol', to.query.rol || '');
    localStorage.setItem('rolDescripcion', to.query.rolDescripcion || '');

    // IMPORTANTE: Limpiar TODAS las marcas de redirección de Vue 3 para evitar bucles
    console.log('🧹 [Vue 2 Router Guard] Limpiando marcas de redirección de Vue 3');
    try {
      sessionStorage.removeItem('vue3_redirected_to_vue2');
      sessionStorage.removeItem('vue3_is_redirecting');
      console.log('✅ [Vue 2 Router Guard] Marcas de redirección limpiadas');
    } catch (e) {
      console.warn('⚠️ [Vue 2 Router Guard] No se pudo limpiar sessionStorage:', e);
    }

    // Redirigir al Dashboard sin los parámetros en la query
    console.log('🔄 [Vue 2 Router Guard] Redirigiendo al Dashboard sin query params');
    next({ name: 'Dashboard', replace: true });
    return;
  }

  const tokenLS = localStorage.getItem('token');
  console.log('🔍 [Vue 2 Router Guard] Token en localStorage:', tokenLS ? 'EXISTS' : 'NO EXISTE');

  if (
    to.name !== 'Login' &&
    to.name !== 'Register' &&
    to.name !== 'afterVerifyError' &&
    to.name !== 'afterVerifyOk' &&
    !tokenLS
  ) {
    console.log('❌ [Vue 2 Router Guard] Sin token, redirigiendo a Login');
    next({ name: 'Login' });
  } else {
    console.log('✅ [Vue 2 Router Guard] Permitiendo navegación');
    next();
  }
});

export default router;
